export default (params) => {
  const {
    currentOrganizationOrdinal,
    organizationNames,
    nextOrganizationNameKey,
    editor,
  } = params;

  let deletedOrganizationReached = false;
  let updatedOrdinal = currentOrganizationOrdinal;

  organizationNames.forEach((organizationName) => {
    const { key: organizationNameKey } = organizationName;
    if (
      !deletedOrganizationReached &&
      organizationNameKey === nextOrganizationNameKey
    ) {
      deletedOrganizationReached = true;
    }

    if (deletedOrganizationReached) {
      const {
        value: { document: updatedDocument },
      } = editor;
      const organizationDetails =
        updatedDocument.getParent(organizationNameKey);

      const nextOrganization = updatedDocument.getParent(
        organizationDetails.key,
      );
      const { key: nextOrganizationKey, data: nextOrganizationData } =
        nextOrganization;

      const nextOrganizationDataJSON = nextOrganizationData.toJSON();
      editor.setNodeByKey(nextOrganizationKey, {
        data: {
          ...nextOrganizationDataJSON,
          Ordinal: updatedOrdinal,
        },
      });
      updatedOrdinal += 1;
    }
  });
};
